import state from "./state";

import { IMutations } from "@/interfaces/state.interface";

const mutations: IMutations = {
	setCurrentRoute: (name, props = {}) => {
		state.router.current = name;
		state.router.props = props;
	},
	setOriginPortal: (portalType) => {
		state.portal = portalType;
	},
	setPreferredPortal: (portalType) => {
		state.preferredPortalType = portalType
	},
	setUserName: (name) => {
		state.userName = name;
	},
	answerQuestion: (answerObject) => {
		state.questions[answerObject.id].answer = answerObject.answer;
	},
	setLoggedInFlag: (isLoggedIn) => {
		state.isLoggedIn = isLoggedIn;
	}
};

export default mutations;